export enum WarningType {
  cardExpiringSoon = 'cardExpiringSoon',
  cardExpired = 'cardExpired',
  paymentFailed = 'paymentFailed',
  accountLocked = 'accountLocked',
  cardAuthenticationFailed = 'cardAuthenticationFailed',
}
